<template>
    <div class="virtual-keyboard">
        <div class="keyboard">
            <button v-for="num in numbers" :key="num" @click.stop="appendToDisplay(num)" class="key">
                {{ num }}
            </button>
            <button @click.stop="backspace" class="key">删除</button>
            <button @click.stop="clear" class="key">清空</button>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        oldid: {
            require: true,
            type: [Number, String]
        }
    },
    data() {
        return {
            id: "",
        };
    },
    mounted() {
        this.id=this.oldid
    },
    computed: {
        numbers() {
            return [1, 2, 3, 4, 5, 6, 7, 8, 9, 0];
        },
    },
    watch: {

    },
    methods: {
        appendToDisplay(char) {
            this.id = Number(this.id + JSON.stringify(char));
            this.renewal()
        },
        backspace() {
            let num = this.id;
            if (num >= 10) {
                this.id = parseInt(num.toString().slice(0, -1));
            } else {
                this.id = ''
            }
            this.renewal()
        },
        clear(){
            this.id = ''
            this.renewal()
        },
        renewal() {
            this.$emit('renewal', this.id)
        }

    },
};
</script>
<style lang="less" scoped>
.virtual-keyboard {
    background: #fff;
    width: 200px;
    margin: 20px auto;
    border-radius: 5px;
    padding: 10px;
}

input[type="text"] {
    width: calc(100% - 15px);
    margin-bottom: 10px;
    padding: 5px;
}

.keyboard {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 5px;
}

.key {
    width: 100%;
    height: 40px;
    border: none;
    background-color: #f0f0f0;
    border-radius: 5px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.key:hover {
    background-color: #e0e0e0;
}

.confirm-key {
    //grid-column: span 1;
    background-color: #007bff;
    border: 0;
    cursor: pointer;
    color: #fff;
    border-radius: 4px;
}

.confirm-key:hover {
    background-color: #007bff;
}
</style>